import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
interface SuccessStateProps {
  title: string;
  message: string;
  onClose: () => void;
  action?: React.ReactNode;
}
export function SuccessState({
  title,
  message,
  onClose,
  action
}: SuccessStateProps) {
  return <motion.div className="flex flex-col items-center py-6 text-center" initial={{
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.22,
    ease: [0.23, 1, 0.32, 1]
  }} role="status" data-id="element-354" data-mp="w197atfsw23x">
      <div className="flex h-14 w-14 items-center justify-center rounded-full border border-neon text-neon" data-id="element-355" data-mp="myhscjnpuo7j">
        <CheckIcon className="h-7 w-7" data-id="element-356" data-mp="i2sqg9o84v82" />
      </div>
      <h3 className="mt-5 font-display text-2xl font-semibold text-white" data-id="element-357" data-mp="d2n4na4my2xw">{title}</h3>
      <p className="mt-2 max-w-sm text-sm leading-6 text-muted" data-id="element-358" data-mp="2cf92jr3pb3ku">{message}</p>
      {action && <div className="mt-6 w-full max-w-sm" data-id="element-359" data-mp="27fw7wk6l8s7p">{action}</div>}
      <button type="button" onClick={onClose} className={action ? 'mt-3 h-11 rounded-lg px-6 text-sm font-medium text-muted transition-colors duration-150 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-neon' : 'mt-6 h-11 rounded-lg bg-neon px-6 text-sm font-semibold text-ink transition-colors duration-150 hover:bg-neon-bright focus:outline-none focus-visible:ring-2 focus-visible:ring-neon focus-visible:ring-offset-2 focus-visible:ring-offset-panel'} data-id="element-360" data-mp="27gfmbqx14ygz">
        Volver al catálogo
      </button>
    </motion.div>;
}